import { COUNTRY_BE } from "../constants/CountryConstants";
import { BE_DELIVERY_ZIP_RANGES } from "../constants/DeliveryConstants";

/**
 * Check if house number is a number and doesnt contain a dot
 * @param houseNumber
 * @returns {boolean}
 */
export const validateHouseNumber = (houseNumber) => {
  return (
    !isNaN(houseNumber) &&
    houseNumber.indexOf(".") === -1 &&
    houseNumber.length <= 5
  );
};

export const validateZipCode = (zipCode, countryCode) => {
  if (countryCode === COUNTRY_BE) {
    let regex = /^[1-9][0-9]{3}$/i;
    return regex.test(zipCode);
  } else {
    let regex = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i;
    return regex.test(zipCode);
  }
};

/**
 * Komt SooCool op deze postcode bezorgen?
 *
 * Dit staat bewust LOS van `validateZipCode`. Die controleert de VORM van een
 * postcode; deze controleert of het adres binnen het bezorggebied van SooCool
 * valt. Twee vragen, twee meldingen: "1234" is geen geldige Belgische postcode,
 * maar "4000" is dat wel en wordt alleen niet bezorgd.
 *
 * Nederland is in zijn geheel bezorggebied. Voor Belgie gelden de drie reeksen
 * uit `BE_DELIVERY_ZIP_RANGES` (artikel 5 van de SooCool-overeenkomst).
 *
 * Een postcode die geen vier cijfers is geeft `true`: dan is de vorm het
 * probleem en hoort `validateZipCode` het woord te doen, niet deze functie.
 *
 * @param {string} zipCode De ingevulde postcode
 * @param {string} countryCode "NL" | "BE"
 * @returns {boolean} False alleen als aantoonbaar buiten het bezorggebied
 */
export const isDeliverableZipCode = (zipCode, countryCode) => {
  if (countryCode !== COUNTRY_BE) return true;

  const digits = String(zipCode ?? "").replace(/\s/g, "");
  if (!/^[0-9]{4}$/.test(digits)) return true;

  const numericZip = Number(digits);
  return BE_DELIVERY_ZIP_RANGES.some(
    (range) => numericZip >= range.from && numericZip <= range.to,
  );
};

/**
 * Check if addition is 2 characters, only letters and numbers
 * @param addition
 * @returns {boolean}
 */
export const validateAddition = (addition) => {
  if (addition === null) return true;
  let regex = /^[A-Z0-9]{0,2}$/i;
  return regex.test(addition) || typeof addition === "undefined";
};
